var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenubutton01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 499 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcc956;}.cls-2{fill:#ce730f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.13,87.64a38.64,38.64,0,1,1,0-77.28H447.36a38.64,38.64,0,0,1,0,77.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.36,13.36A35.64,35.64,0,0,1,483,49h0a35.64,35.64,0,0,1-35.64,35.64H53.13A35.64,35.64,0,0,1,17.48,49h0A35.64,35.64,0,0,1,53.13,13.36H447.36m0-6H53.13a41.64,41.64,0,1,0,0,83.28H447.36a41.64,41.64,0,0,0,0-83.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenubutton01);
export default __webpack_public_path__ + "static/media/Menu button-01.8fa415dae32b56f9c2ee4e48918b62ad.svg";
export { ForwardRef as ReactComponent };